export const SET_SESSION = 'app/Session/SET_SESSION';
export const CLEAR_SESSION = 'app/Session/CLEAR_SESSION';
export const SET_TAB_ORDERS = 'app/Session/SET_TAB_ORDERS';
